import { useCallback, useEffect, useState } from "react";
import ReactExport from "react-export-excel";
import { Search } from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  Button,
} from "@material-ui/core";

// @material-ui/lab components
import { Skeleton } from "@material-ui/lab";

// @material-ui/icons components
import {
  Delete,
  Refresh as RefreshIcon,
  Add as AddIcon,
} from "@material-ui/icons";

// core components
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import FormDenyListDialog from "components/Dialogs/FormDenyListDialog";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const getTableColumns = (setSelectedMenu, toggleFormDialog, searching) => [
  {
    dataField: "email",
    text: "E-mail",
    sort: true,
    csvExport: true,
    formatter: (menu) => (searching ? <Skeleton variant="text" /> : menu),
  },
  {
    dataField: "deletar",
    text: "",
    isDummyField: true,
    headerStyle: { width: 45 },
    formatter: (cell, row) =>
      searching ? null : (
        <Tooltip title="Excluir E-mail">
          <IconButton
            aria-label="delete"
            onClick={() => {
              setSelectedMenu(row);
              toggleFormDialog("delete");
            }}
          >
            <Box
              component={Delete}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      ),
  },
];

const loadingItems = [
  { IdMenu: "0" },
  { IdMenu: "1" },
  { IdMenu: "2" },
  { IdMenu: "3" },
  { IdMenu: "4" },
  { IdMenu: "5" },
  { IdMenu: "6" },
  { IdMenu: "7" },
  { IdMenu: "8" },
  { IdMenu: "9" },
];

const { SearchBar } = Search;

const useStyles = makeStyles(componentStyles);

const exportIconStyle = {
  width: 28,
  height: 28,
  marginLeft: 10,
};

function DenyList() {
  const classes = useStyles();
  const snackbar = useSnackbar();

  const [emails, setEmails] = useState(loadingItems);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [searching, setSearching] = useState(true);

  const isMobile = IsMobile();

  const toggleFormDialog = useCallback((formType) => {
    if (formType) {
      setOpenFormDialog(formType);
    }
  }, []);

  const fetchList = async () => {
    await Api.get("deny-contact-list", "denylist", "", true)
      .then(({ Success, Result }) => {
        if (Success) {
          let newObject = {};
          const newEmailList = [];

          // eslint-disable-next-line array-callback-return
          Result?.map((email) => {
            newObject = {
              email: email?.Valor,
              id: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
            };
            newEmailList.push(newObject);
          });
          setEmails(newEmailList);
          setSearching(false);
        }
      })
      .catch((error) => {
        snackbar.showMessage(error, {
          severity: "error",
        });      });
  };

  const handleRefresh = async () => {
    setSearching(true);

    return fetchList();
  };

  const ExportExcelIcon = () => {
    return (
      <Tooltip title="Exportar e-mails">
        <IconButtonLoader
          extraStyle={exportIconStyle}
          icon={
            <img
              src="https://img.icons8.com/material-outlined/72/000000/xls-export.png"
              alt="ícone clicável para exportar a tabela no formato Excel"
              style={exportIconStyle}
            />
          }
          size="small"
        />
      </Tooltip>
    );
  };

  const exportCmp = (
    <ExcelFile element={<ExportExcelIcon />} filename={"Lista de e-mails"}>
      <ExcelSheet data={emails} name={"Lista de e-mails"}>
        <ExcelColumn label="E-mail" value="email" />
      </ExcelSheet>
    </ExcelFile>
  );

  useEffect(() => {
    fetchList();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderClientes section="Deny List" subsection="Administração" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <ToolkitTable
          keyField="id"
          dataTable={searching ? loadingItems : emails}
          columnModel={getTableColumns(
            setSelectedEmail,
            toggleFormDialog,
            searching
          )}
          search
          allowEmpty
          CustomHeader={({ searchProps }) => (
            <Grid
              container
              className="pl-4"
              style={
                isMobile
                  ? {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      flexDirection: "column",
                      marginBottom: "1rem",
                    }
                  : { padding: "0 24px" }
              }
            >
              <Grid
                item
                xs={isMobile ? 12 : 4}
                style={isMobile ? { marginBottom: "1rem" } : {}}
              >
                <Box
                  component={Typography}
                  variant="h2"
                  marginBottom="0!important"
                >
                  <Box component="span">Lista de E-mails</Box>
                  <IconButtonLoader
                    size="medium"
                    extraStyle={{
                      width: 24,
                      height: 24,
                      marginLeft: "0.3rem",
                    }}
                    title="Recarregar lista"
                    onClick={handleRefresh}
                    icon={<RefreshIcon color="primary" />}
                    aria-label="refresh"
                    color="primary"
                    disabled={searching}
                  />
                </Box>
              </Grid>
              <Grid
                container
                spacing={2}
                xs={isMobile ? 12 : 8}
                style={
                  isMobile
                    ? {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        flexDirection: "column",
                      }
                    : {
                        display: "flex",
                        alignItems: "baseline",
                        justifyContent: "flex-end",
                      }
                }
              >
                <SearchBar
                  className="form-control"
                  placeholder="Pesquisar E-mail"
                  {...searchProps}
                  disabled={searching}
                />
                <Box
                  justifyContent="flex-end"
                  display="flex"
                  flexWrap="wrap"
                  style={isMobile ? { marginTop: "1rem" } : { marginLeft: 15 }}
                >
                  <Button
                    variant="contained"
                    classes={{
                      root: classes.buttonRootWhite,
                    }}
                    onClick={() => toggleFormDialog("create")}
                    disabled={searching}
                  >
                    <Box component={AddIcon} position="relative" top="-2px" />
                    Adicionar e-mail
                  </Button>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    {exportCmp}
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          )}
          pagination={{
            options: [25, 50, 100],
            defaultOption: 25,
          }}
        />
      </Container>
      {Boolean(openFormDialog) && (
        <FormDenyListDialog
          open
          formType={openFormDialog}
          onClose={(email) => {
            setSelectedEmail(null);
            if (email === "delete" || email === "create") {
              handleRefresh();
            }
            setOpenFormDialog(false);
          }}
          selectedEmail={selectedEmail}
        />
      )}
    </>
  );
}

DenyList.propTypes = {};

export default DenyList;
